import React from 'react';
import { LazyPicture } from 'src/hooks/useLazyLoad';
import { useSetResolved } from 'src/core/engine/router/useSetResolved';
import { CategoriesList } from 'src/components/CategoriesList/CategoriesList';

import { Container } from '../Layout';

import classes from './CategoryLandingPage.scss';

export type BrandItem = {
    label: string;
    image: string;
};

export type FaqItem = {
    question: string;
    answer: string;
};

type Props = {
    name: string;
    description: string | null;
    shortDescription: string | null;
    categories: any;
    heroDesk: string | null;
    heroMob: string | null;
    featuredSku: string | null;
    extendedDescription: string | null;
    categoryId?: number | null;
    brands: BrandItem[];
    relatedCategories: string[];
    featuredPrintedSku: string | null;
    featuredEmbroideredSku: string | null;
    faq: FaqItem[];
    displayFullView: boolean;
};

export const CategoryLandingPage: React.FunctionComponent<Props> = ({
    name,
    description,
    categories,
    heroDesk,
    heroMob,
    shortDescription,
    featuredSku,
    extendedDescription,
    categoryId,
    brands,
    relatedCategories,
    featuredPrintedSku,
    featuredEmbroideredSku,
    faq,
    displayFullView,
}) => {
    useSetResolved();
    return (
        <>
            {heroDesk && heroMob && (
                <section className={classes.hero}>
                    <LazyPicture data-alt={name} className={classes.heroImage}>
                        <source media="(min-width: 900px)" srcSet={heroDesk} />
                        <source media="(max-width: 900px)" srcSet={heroMob} />
                    </LazyPicture>
                </section>
            )}

            <Container>
                {categories && name && (
                    <CategoriesList
                        title={name}
                        categories={categories}
                        richText={description}
                        shortDescription={shortDescription}
                        featuredSku={featuredSku}
                        featuredPrintedSku={featuredPrintedSku}
                        featuredEmbroideredSku={featuredEmbroideredSku}
                        extendedDescription={extendedDescription}
                        displayHeader
                        categoryId={categoryId}
                        brands={brands}
                        relatedCategories={relatedCategories}
                        faq={faq}
                        displayFullView={displayFullView}
                    />
                )}
            </Container>
        </>
    );
};
